import { importLibrary, setOptions } from "@googlemaps/js-api-loader";
import { getGooglePlacesApiKey } from "../../utils/google-places-key";

let mapsLoadPromise = null;

async function resolveApiKey() {
  return getGooglePlacesApiKey();
}

export async function loadGooglePlaces() {
  if (mapsLoadPromise) return mapsLoadPromise;

  const apiKey = await resolveApiKey();
  if (!apiKey) return null;

  mapsLoadPromise = (async () => {
    setOptions({ key: apiKey, v: "weekly" });
    await importLibrary("places");
    const mapsGlobal = typeof window !== "undefined" ? window.google : undefined;
    if (!mapsGlobal) {
      throw new Error("Google Maps failed to load");
    }
    return mapsGlobal;
  })().catch((err) => {
    mapsLoadPromise = null;
    throw err;
  });

  return mapsLoadPromise;
}

export function parsePlaceAddress(place) {
  const components = place?.address_components ?? [];
  let streetNumber = "";
  let route = "";
  let line2 = "";
  let city = "";
  let state = "";
  let stateLong = "";
  let postalCode = "";

  for (const component of components) {
    const types = component.types || [];
    if (types.includes("street_number")) {
      streetNumber = component.long_name;
    } else if (types.includes("route")) {
      route = component.long_name;
    } else if (types.includes("subpremise")) {
      line2 = component.long_name;
    } else if (types.includes("locality")) {
      city = component.long_name;
    } else if (!city && types.includes("sublocality")) {
      city = component.long_name;
    } else if (
      !city &&
      types.includes("administrative_area_level_3")
    ) {
      city = component.long_name;
    } else if (
      !city &&
      types.includes("postal_town")
    ) {
      city = component.long_name;
    } else if (types.includes("administrative_area_level_1")) {
      state = String(component.short_name || "").trim();
      stateLong = String(component.long_name || "").trim();
    } else if (types.includes("postal_code")) {
      postalCode = component.long_name;
    }
  }

  const line1 =
    [streetNumber, route].filter(Boolean).join(" ").trim() ||
    place?.formatted_address?.split(",")[0]?.trim() ||
    "";

  return {
    line1,
    line2: String(line2 || "").trim(),
    city: String(city || "").trim(),
    state: state.toUpperCase(),
    stateLong,
    postalCode: String(postalCode || "").trim(),
  };
}
